import React, { FunctionComponent } from "react";
import { ContentText } from "../../text/content-text";
import { TextWithReferences } from "./text-with-references";

interface IContentWithIconButtonProps {
  text: string;
}

export const ContentWithIconButton: FunctionComponent<IContentWithIconButtonProps> = (props) => {
  const { text } = props;
  return (
    <ContentText small light>
      <TextWithReferences text={text} />
    </ContentText>
  );
};
